(function ($) {
    "use strict";
  jQuery(document).ready(function(){
	
		$('[data-toggle="tooltip"]').tooltip();
		/*---------------------
		 jQuery MeanMenu
		--------------------- */
		jQuery('nav#dropdown').meanmenu();
    
    
    	$('.single_megamenu').parent('div').addClass('mega-menu-new');
    
    

		/*==========================
		Blog carousel js active
		==========================*/
		$(".blog_list_area").owlCarousel({
			  navigation : true, 
			  slideSpeed : 300,
			  paginationSpeed : 400,
			  singleItem:true,
			  pagination:false,
			  autoPlay:true,
		  });
		  
	
		
		 /*==========================
		Carousel Branding js active
		==========================*/
		$(".carousel_branding").owlCarousel({
			items:6,
			itemsDesktop:[1199,6],
			itemsDesktopSmall:[979,4],
			itemsTablet:[768,3],
			itemsMobile:[479,2],
			slideSpeed : 500,
			paginationSpeed : 500,
			rewindSpeed : 500,
			pagination:false,
			navigation:true
		}); 
	  
        $(".product-single_thumbnails").owlCarousel({
          items : 3,
          itemsDesktop : [1199,2],
          itemsDesktopSmall : [768,2],
          itemsTablet: [767,2],
          itemsMobile : [479,1],
          slideSpeed : 1500,
          paginationSpeed : 1500,
          rewindSpeed : 1500,
          navigation : true,
          pagination : false,
          addClassActive: true,
        });

		   
		/*==========================
		Upsell Product list js active
		==========================*/
		$(".upsell_product_list").owlCarousel({
			items:4,
			itemsDesktop:[1199,4],
			itemsDesktopSmall:[979,3],
			itemsTablet:[768,2],
			itemsMobile:[479,1],
			slideSpeed : 500,
			paginationSpeed : 500,
			rewindSpeed : 500,
			pagination:false,
			navigation:true
		});

    
    $(".zoom1").elevateZoom({
      gallery:'gallery_01',
      cursor: 'pointer',
      galleryActiveClass: 'active',
      imageCrossfade: true,
      });
    /*----------------------------
         Elevate Zoom active
    ------------------------------ */
  $(".zoom1").elevateZoom({
    gallery:'gallery_01',
    cursor: 'pointer',
    imageCrossfade: true
  });     
    
    
    
    $(".zoom1").bind("click", function(e) {
      var ez = $('.zoom1').data('elevateZoom');
      $.fancybox(ez.getGalleryList());
      return false; });
    
    /*---------------------
				   Circular Bars - Knob
				--------------------- */	
					  if(typeof($.fn.knob) != 'undefined') {
						$('.knob').each(function () {
						  var $this = $(this),
							  knobVal = $this.attr('data-rel');
					
						  $this.knob({
							'draw' : function () { 
							  $(this.i).val(this.cv + '%')
							}
						  });
						  
						  $this.appear(function() {
							$({
							  value: 0
							}).animate({
							  value: knobVal
							}, {
							  duration : 2000,
							  easing   : 'swing',
							  step     : function () {
								$this.val(Math.ceil(this.value)).trigger('change');
							  }
							});
						  }, {accX: 0, accY: -150});
						});
					  }	
    
    
    
    
		
		

			
			   

	
});	

})(jQuery);